import { Question, Answer } from "./question";
import { JsonTreeTranslators, Convert } from '@virtual-mgr/json-tree';
import { ILingoAnswer } from "../../lingojs/lingo-answers-context";
import { IDateTimeQuestionDefinition, DesignDateTimeQuestion } from 'lingo-api';
import { IDateTimeAnswer, IPresentedDateTimeQuestion } from "../../presented-types";


export class DateTimeQuestion extends Question implements DesignDateTimeQuestion {
	defaultAnswer?: Date;
	allowMultiline?: boolean = false;
	constructor() {
		super(`dateTime`);
	}
}

export class DateTimeAnswer extends Answer implements ILingoAnswer {
	constructor(public answer: IDateTimeAnswer, public presentedQuestion: IPresentedDateTimeQuestion) {
		super(answer, presentedQuestion);
	}

	get value() {
		return this.answer.DateTime;
	}
	set value(value: Date | null) {
		this.answer.DateTime = value;
	}
}

JsonTreeTranslators.register({
	ctr: DateTimeQuestion,
	create: () => new DateTimeQuestion()
}, {
	ctr: DateTimeAnswer,
	flatten(o: DateTimeAnswer) {
		return {
			answer: o.answer,
			presentedQuestion: o.presentedQuestion
		}
	},
	fatten(o: any, fatten: Convert, store: Convert) {
		return store(new DateTimeAnswer(fatten(o.answer), fatten(o.presentedQuestion)));
	}
});
